import React from "react";

type CardProps = {
  title?: string;
  icon: {
    src: string;
    alt: string;
  };
  description?: string;
  color?: string;
};

const Card: React.FC<CardProps> = ({ title, description, icon, color }) => {
  return (
    <div className={`category-benefits-card${color ? ` category-benefits-card--${color}` : ""}`}>
      <div className="category-benefits-card__icon">
        <img className="image" src={icon.src} alt={icon.alt ?? title} />
      </div>
      <div className="category-benefits-card__text">
        <div className="category-benefits-card__text--title">{title}</div>
        {description && (
          <p
            className="category-benefits-card__text--description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  );
};

export default Card;

Card.defaultProps = { title: undefined, description: undefined, color: undefined };
